import { PropsWithChildren, useEffect, useMemo } from 'react'
import { MsalAuthGuard } from '@ecrm-msal'
import { AUTH_PROVIDER, getLoginCredentials } from '../utils/constants'
import CognitoAuthGuard from './cognitoAuthGuard'
import LoginAttempt from '../components/common/LoginAttempt'
import { getMsalScopes, msalInstance } from '../utils/msalConfig'

const NavigateToErrorPage: React.FC<{ url: string }> = ({ url }) => {
  useEffect(() => {
    const path = url.startsWith('http') ? url : `${window.location.origin}${url}`
    window.location.assign(path)
  }, [url])
  return null
}

const ProtectedRoute: React.FC<PropsWithChildren> = ({ children }) => {
  const { loginURL, loginClientId, authProvider } = getLoginCredentials()
  const msalScopes = useMemo(() => getMsalScopes(), [])

  if (authProvider === AUTH_PROVIDER.COGNITO) {
    return (
      <CognitoAuthGuard loginClientId={loginClientId} loginURL={loginURL}>
        {children}
      </CognitoAuthGuard>
    )
  } else if (authProvider === AUTH_PROVIDER.MSAL) {
    return (
      <MsalAuthGuard
        scopes={msalScopes}
        msalInstance={msalInstance}
        LoginAttemptComponent={LoginAttempt}
      >
        {children}
      </MsalAuthGuard>
    )
  } else {
    return <NavigateToErrorPage url="/error/user-error" />
  }
}

export default ProtectedRoute
